module.exports = __webpack_public_path__ + "static/media/safe.d906f4be.svg";